export const ADMIN_ROLES = new Set(['ADMIN', 'ADMINISTRADOR']);

export const normalizeRole = (value) => {
  const normalized = (value || '').toString().trim().toUpperCase();
  if (normalized === 'ADMINISTRADOR') {
    return 'ADMIN';
  }
  return normalized;
};

export const isAdminRole = (value) => ADMIN_ROLES.has((value || '').toString().trim().toUpperCase());

export const routeResourceMap = {
  '/dashboard': 'dashboards',
  '/dashboard-executivo-v2': 'dashboards',
  '/dashboard-operacional': 'dashboards',
  '/dashboard-comercial': 'dashboards',
  '/dashboard-rh': 'dashboards',
  '/dashboard-financeiro': 'dashboards',
  '/dashboard-parcelas': 'dashboards',
  '/dashboard-unidades': 'dashboards',
  '/alunos': 'alunos',
  '/turmas': 'turmas',
  '/matriculas': 'matriculas',
  '/relatorios-operacionais': 'relatorios_operacionais',
  '/professor': 'presencas',
  '/presencas': 'presencas_gestao',
  '/aulas-dadas': 'aulas_dadas',
  '/relatorio-mensal': 'relatorio_aulas',
  '/receitas': 'receitas',
  '/parcelas': 'parcelas',
  '/despesas': 'despesas',
  '/fluxo-caixa': 'fluxo_caixa',
  '/fornecedores': 'fornecedores',
  '/categorias-despesa': 'categorias_despesa',
  '/folha-pagamento': 'folha_pagamento',
  '/equipe': 'equipe',
  '/usuarios': 'usuarios',
  '/perfis': 'perfis',
  '/responsaveis/pendentes': 'responsaveis',
  '/unidades': 'unidades',
  '/tipo-unidades': 'tipo_unidades',
  '/tipo-contratos': 'tipo_contratos',
  '/modalidades': 'modalidades',
  '/series': 'series',
  '/configuracoes/financeiro': 'usuarios',
  '/conta/assinatura': 'conta_assinatura',
  '/faturas/operacional': 'faturas',
  '/faturas/gestao': 'faturas',
  '/relatorios-contabeis': 'relatorios_contabeis',
};

export const menuItemIdsByRoute = {
  '/dashboard': [1, 20],
  '/dashboard-executivo-v2': [1, 20],
  '/dashboard-financeiro': [21],
  '/dashboard-operacional': [22],
  '/dashboard-comercial': [23],
  '/dashboard-rh': [24],
  '/dashboard-unidades': [25],
  '/responsavel/dashboard': [26],
  '/unidades': [2],
  '/tipo-unidades': [3],
  '/tipo-contratos': [4],
  '/modalidades': [5],
  '/equipe': [6],
  '/turmas': [7],
  '/alunos': [8],
  '/matriculas': [9],
  '/aulas-dadas': [10],
  '/fornecedores': [11],
  '/categorias-despesa': [12],
  '/despesas': [13],
  '/receitas': [14],
  '/fluxo-caixa': [15],
  '/folha-pagamento': [16],
  '/responsaveis/pendentes': [17],
  '/usuarios': [18],
  '/perfis': [19],
  '/configuracoes/financeiro': [18],
};
